import {Load} from "./Load";
import {Basic} from "./Basic";
import {Display} from "./Display";

export class Chronicle
{
    static initialize()
    {
        Chronicle.timeline = document.getElementById('w--chronicle-timeline');
        Chronicle.year = document.getElementById('w--load-into');

        if(Chronicle.timeline && Chronicle.year)
        {
            Chronicle.timeline.classList.add('active');
            setTimeout(() =>
            {
                Chronicle.adjust_timeline();
            },250);
        }
    }

    static load(el)
    {
        Load.post({
            f: 'chronicle',
            orchestraId: parseInt(Chronicle.timeline.dataset.orchestraId),
            year: el.textContent,
            url: el.href
        }).then(r => {
            document.getElementById('w--load-into').style.opacity = '0';
            setTimeout(() => {
                Basic.update_page(r, el.href,true);
            },500);

        }).catch(r => {
            console.error(r, el.href);
        });
    }

    static move_timeline(el)
    {
        const timeline = Chronicle.timeline.querySelector('.w__chronicle--timeline');
        let stylePos = Chronicle.get_timelineStylePos(timeline);

        if(el.classList.contains('mod--prev'))
        {
            stylePos += Chronicle.timeline.getBoundingClientRect()['width'] / 2;
        }
        else
        {
            stylePos -= Chronicle.timeline.getBoundingClientRect()['width'] / 2;
        }

        const min = Chronicle.get_targetPosition(Chronicle.timeline.querySelector('li:first-child a'), timeline),
            max = Chronicle.get_targetPosition(Chronicle.timeline.querySelector('li:last-child a'), timeline);

        if(stylePos < max)
        {
            stylePos = max;
        }
        else if(stylePos > min)
        {
            stylePos = min;
        }

        timeline.style.transform = 'translateX(' + stylePos.toString() + 'px)';
    }

    static get_timelineStylePos(timeline)
    {
        let stylePos = parseFloat(timeline.style.transform.replace(
            /translateX\(([-.\d]+)px\)/i,
            '$1'));
        if(isNaN(stylePos))
        {
            stylePos = 0;
        }

        return stylePos;
    }

    static adjust_timeline()
    {
        if(Chronicle.timeline)
        {
            const el = Chronicle.timeline.querySelector('li.active a'),
                  timeline = Chronicle.timeline.querySelector('.w__chronicle--timeline');
            if(el && timeline)
            {
                const stylePos = Chronicle.get_targetPosition(el, timeline);
                timeline.style.transform = 'translateX(' + stylePos.toString() +'px)';
            }
        }
    }

    static get_targetPosition(el, timeline)
    {
        const elPos = el.getBoundingClientRect()['left'],
              targetPos = document.getElementById('w--load-into')
                                  .querySelector('.w__module--text-main')
                                  .getBoundingClientRect()['left'],
              stylePos = Chronicle.get_timelineStylePos(timeline);

        return (elPos - targetPos) * -1 + stylePos;
    }

    static set_active(el)
    {
        const activeEl = Chronicle.timeline.querySelector('li.active');
        if(activeEl)
        {
            activeEl.classList.remove('active');
        }
        el.closest('li').classList.add('active');
        Chronicle.load(el);
    }
}